export const instrumentationKey = '9d7d2da1-fb83-42fd-aaef-0299f379a173';
export const environment = 'local-env';
export const version = 'local-rel';

export enum EventTypes {
  ADS_CONSOLE_ERROR = 'ADS Console Error',
  COMPONENT_REGISTER = 'Component Register',
}
